module.exports = __webpack_public_path__ + "static_pc/img/26.88687f2b.jpg";